// -d moved few line of code to swiper-bundle-min.js
// testimonials slider
/*
var swiper = new Swiper(".testimonials-slider", {
  slidesPerView: 2.5,
  spaceBetween: 32,
  centeredSlides:false,
  navigation: {
    nextEl: ".test-swiper-button-next",
    prevEl: ".test-swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 30
    },
    640: {
      slidesPerView: 1.25,
      spaceBetween: 25
    },
    989: {
      slidesPerView: 1.75,
      spaceBetween: 20
    },
    1199: {
      slidesPerView: 2.5,
      spaceBetween: 15
    }
  }
});

var collection_list_swiper = new Swiper('.blog_slider', {
      loop: false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      direction: 'horizontal',
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      navigation: {
        nextEl: '.blog-swiper-button-next',
        prevEl: '.blog-swiper-button-prev',
      },
      speed: 500,
      breakpoints: { 
        320: { 
          slidesPerView: 1,
          spaceBetween: 10 
        },
        768: { 
          slidesPerView: 2,
          spaceBetween: 10 
        },
        992: { 
          slidesPerView: 3,
          spaceBetween: 16
        },
        1200: { 
          slidesPerView: 3,
          spaceBetween: 16
        }
      }
    });

// blog page video Educational Content Slider
var swiper = new Swiper(".educational_content_swap", {
  slidesPerView: 2.5,
  spaceBetween: 32,
  centeredSlides:false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    640: {
      slidesPerView: 1.25,
      spaceBetween: 15
    },
    989: {
      slidesPerView: 1.75,
      spaceBetween: 20
    },
    1199: {
      slidesPerView: 2.5,
      spaceBetween: 30
    }
  }
});

// feature product Slider
var swiper = new Swiper(".feature-product-slider", {
  loop: true,
  slidesPerView: 4,
  spaceBetween: 15,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".collection-swiper-button-next",
    prevEl: ".collection-swiper-button-prev",
  },
  speed: 500,
  breakpoints: { 
    320: { 
      slidesPerView: 1,
      spaceBetween: 50 
    },
    768: { 
      slidesPerView: 2,
      spaceBetween: 10 
    },
    992: { 
      slidesPerView: 3,
      spaceBetween: 16
    },
    1200: { 
      slidesPerView: 4,
      spaceBetween: 16
    }
  }
});
*/
document.addEventListener('DOMContentLoaded', function () {
  const swiperSelectors = [
    '.testimonials-slider',
    '.blog_slider',
    '.educational_content_swap',
    '.feature-product-slider'
  ];

  const hasSwiper = swiperSelectors.some(function (selector) {
    return document.querySelector(selector);
  });

  if (!hasSwiper || !window.swiperAssetUrl) return;

  const swiperScript = document.createElement('script');
  swiperScript.src = window.swiperAssetUrl;

  swiperScript.onload = function () {
    initCustomSwipers();
  };

  document.head.appendChild(swiperScript);
});

function initCustomSwipers() {

  // testimonials slider
  if (document.querySelector('.testimonials-slider')) {
    new Swiper('.testimonials-slider', {
      slidesPerView: 2.5,
      spaceBetween: 32,
      centeredSlides: false,
      navigation: {
        nextEl: '.test-swiper-button-next',
        prevEl: '.test-swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 30
        },
        640: {
          slidesPerView: 1.25,
          spaceBetween: 25
        },
        989: {
          slidesPerView: 1.75,
          spaceBetween: 20
        },
        1199: {
          slidesPerView: 2.5,
          spaceBetween: 15
        }
      }
    });
  }

  // Blog slider
  if (document.querySelector('.blog_slider')) {
    new Swiper('.blog_slider', {
      loop: false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      direction: 'horizontal',
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      navigation: {
        nextEl: '.blog-swiper-button-next',
        prevEl: '.blog-swiper-button-prev',
      },
      speed: 500,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 16
        }
      }
    });
  }

  // Educational Content Slider
  if (document.querySelector('.educational_content_swap')) {
    new Swiper('.educational_content_swap', {
      slidesPerView: 2.5,
      spaceBetween: 32,
      centeredSlides: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        640: {
          slidesPerView: 1.25,
          spaceBetween: 15
        },
        989: {
          slidesPerView: 1.75,
          spaceBetween: 20
        },
        1199: {
          slidesPerView: 2.5,
          spaceBetween: 30
        }
      }
    });
  }

  // Feature product Slider
  if (document.querySelector('.feature-product-slider')) {
    new Swiper('.feature-product-slider', {
      loop: true,
      slidesPerView: 4,
      spaceBetween: 15,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.collection-swiper-button-next',
        prevEl: '.collection-swiper-button-prev',
      },
      speed: 500,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 50
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 16
        }
      }
    });
  }
}

// blog page load more 
$(".btn_show-more").on('click',function(){
  $('.blog-articles__article.hidden').each(function(index,item){
    console.log("welcome");
    if(index < 4){
      $(item).removeClass('hidden');
    }
  });
  if($(".blog-articles__article.hidden").length == 0){
    $(this).addClass('hidden');
  }
}); 

$(document).ready(function() {
  $('.popup-youtube').magnificPopup({
    type: 'iframe',
    iframe: {
      patterns: {
        youtube: {
          index: 'youtube.com/', 
          id: 'v=', 
          src: 'https://www.youtube.com/embed/%id%?autoplay=1' 
        }
      }
    },
    callbacks: {
        close: function() {
          $('.custom-play-btns').removeClass('hidden')
        },
        elementParse: function(item) {
          console.log();
          var itemElm = item.el[0];
          $(itemElm).find('.custom-play-btns').addClass('hidden');
        }
    },
  });
});

// blog page search bar
// document.addEventListener("DOMContentLoaded", function() {
//   const searchInput = document.getElementById('articleSearch');

//   // searchInput.addEventListener('keyup', function() {
//     const query = searchInput.value.toLowerCase();
//     const articles = document.querySelectorAll('.article');

//     articles.forEach(function(article) {
//       const title = article.querySelector('h2').innerText.toLowerCase();
//       const content = article.querySelector('div').innerText.toLowerCase();

//       if (title.includes(query) || content.includes(query)) {
//         article.style.display = 'block';
//       } else {
//         article.style.display = 'none';
//       }
//     });
//   // });
// });


// Footer Accordion Function

$(function () {
  if ($(window).width() < 991) {
    var Accordion = function (el, multiple) {
      this.el = el || {};
      //More Than One Menu Open
      this.multiple = multiple || false;
  
      var dropdownlink = this.el.find('.footer-block__heading');
      dropdownlink.on('click', {
        el: this.el,
        multiple: this.multiple
      },
        this.dropdown
      );
    };
    
    Accordion.prototype.dropdown = function (e) {
      var $el = e.data.el,
          $this = $(this),
          //ul submenuItems
          $next = $this.next();
  
      $next.slideToggle();
      $this.parent().toggleClass('open');
  
      // if (!e.data.multiple) {
      //   Show Only one Menu at the same time
      //   $el.find('.footer-block__details-content').not($next).slideUp().parent().removeClass('open');
      // }
    };
    //Set Object
    var accordion = new Accordion($('.footer__blocks-wrapper'), false);  
  }
});


// header menu hover effect
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");

items.forEach(item => {
 item.addEventListener("mouseover", () => {
  item.setAttribute("open", true);
   item.querySelector("ul").addEventListener("mouseleave", () => {
     item.removeAttribute("open");
   });
   item.addEventListener("mouseleave", () => {
     item.removeAttribute("open");
   });
 });
});